@let hasBottomSheetModal = dataService.hasEventData().bottomSheet;

<div
  role="contentinfo"
  class="footer-wrapper"
  [style]="{
    ...config().styles,
    padding: hasBottomSheetModal
      ? '20px 0 6.5rem 0'
      : config().styles['padding'],
  }"
>
  <div class="footer-links">
    @for (item of config().links; track $index) {
      <b2c-footer-link
        [item]="item"
        class="footer-link"
        [itemStyles]="config().linkStyles"
      />
    }
  </div>

  <!-- Template after footer links -->
  @let templateConfig = config().templateFooter;
  @if (templateConfig) {
    <b2c-template [template]="templateConfig[device()]" />
  }
</div>
